import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base'

export default class Customer extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/customer/get", { id: this.getCurrentFormId() })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/customer/save", {
            id: this.getCurrentFormId(),
            name: this.state.data.record.name,
            mobile: this.state.data.record.mobile,
            software_number: this.state.data.record.software_number,
            user_count: this.state.data.record.user_count,
            company_count: this.state.data.record.company_count
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    redirect: '/customers'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }

    renderForm() {
        return (
            <form onSubmit={e => this.save(e)}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="container" id="invoiceDateBox">
                            <div className="form-group">
                                <label>نام مشتری</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>شماره موبایل</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>سریال برنامه</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.record.software_number} onChange={e => this.state.data.record.software_number = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>تعداد کاربر</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.record.user_count} onChange={e => this.state.data.record.user_count = parseInt(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label>تعداد شرکت</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.record.company_count} onChange={e => this.state.data.record.company_count = parseInt(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="container" id="invoiceCustomerBox">
                            <div className="form-group">
                                <label>لایسسنس</label>
                                <textarea className="form-control" type="text" defaultValue={this.state.data.record.licence} style={{ "height":"120px"}}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <button type="submit" className="btn btn-primary">ذخیره</button>
                </div>
            </form>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {this.getToastContainer()}
                {contents}
            </div>
        );
    }
}